export const ExcessPath = {
  REVIEW: 'adjustment/:adjustmentId',
}
